import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Speciality, ExportOptions } from '../models/common-model';
import { Subject, Observable, BehaviorSubject } from 'rxjs';
import { config } from '../power-bi.config';
import { map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class CommonService {

  accessToken: string;

  constructor(private http: HttpClient) { }

  getAllSpecialities() {
    return this.http.get<Speciality[]>(environment.apiUrl + 'LookUp/FetchAllSpecalities');
  }

  getAllAppointmentStatus(flag) {
    return this.http.get<any[]>(environment.apiUrl + 'LookUp/FetchAllAppointmentStatus/' + flag);
  }

  getAllLeadSources() {
    return this.http.get<any[]>(environment.apiUrl + 'LookUp/FetchAllLeadSources');
  }
  getAllUTMCampaignsGroupBy() {
    return this.http.get<any[]>(environment.apiUrl + 'LookUp/FetchAllUTMCampaignsGroupBy');
  }
  getAllBussinessUnits() {
    return this.http.get<any[]>(environment.apiUrl + 'LookUp/FetchAllBussinessUnits');
  }
  getCareManagerEddStatusData() {
    return this.http.get<any[]>(environment.apiUrl + 'LookUp/FetchAllCareManagerEDDStatus');
  }
  getAllCareManagerDoctors() {
    return this.http.get<any[]>(environment.apiUrl + 'LookUp/FetchAllCareManagerDoctors');
  }
  getAllCareManagerSelectOption() {
    return this.http.get<any[]>(environment.apiUrl + 'LookUp/FetchAllCareManagerSelectOption');
  }
  getAllActitivesForFilters() {
    return this.http.get<any[]>(environment.apiUrl + 'LookUp/FetchAllActivitiesMasterData');
  }
  getAllSMSConfigurationDetails() {
    return this.http.get<any[]>(environment.apiUrl + 'LookUp/FetchSMSConfigurationDetailsData');
  }
  FetchAllSubDispositions(callStatusId: number) {
    return this.http.get<any[]>(environment.apiUrl + 'LookUp/FetchAllSubDispositions/'+callStatusId);
  }

  FetchAllDiagnosticSubDispositions(callStatusId: number,businessUnitName : string) {
    return this.http.get<any[]>(`${environment.apiUrl}LookUp/FetchAllSubDispositions/${callStatusId}/?businessUnitName=${businessUnitName}`);
  }


  getCountryCodes() {
    return this.http.get<any[]>("assets/country-code.json");
  }
  getCustomSlots() {
    return this.http.get<any[]>("assets/slots.json");
  }


  private subject = new Subject<any>();
  //invokeEvent: Subject<any> = new Subject();
  openOutBoundCallPopUp() {
    this.subject.next();
  }

  private subject1 = new Subject<any>();

  openOutPopUp(eventType: string) {
    this.subject1.next(eventType); // Emit the event type
  }
  getClickEvent(): Observable<any> {
    return this.subject1.asObservable();
  }

  private booleanSubject = new BehaviorSubject<boolean>(false); // Initial value is false

  // Observable that components can subscribe to
  booleanValue$ = this.booleanSubject.asObservable();

  // Method to change the boolean value
  setBooleanValue(value: boolean) {
    this.booleanSubject.next(value);
  }

  getAccessToken(): Observable<any> {
    let apiUrl = `${environment.apiUrl}PowerBI/GetPowerBIAccessToken`
    return this.http.get(`${apiUrl}`);
  }
  generateEmbedToken = (accessToken: string, workSpaceId: string, reportIdWithoutFilter: string) => {
    let payload = {
      "accessLevel": "View"
    }
    return this.http.post(`${config.apiUrl}v1.0/myorg/groups/${workSpaceId}/reports/${reportIdWithoutFilter}/GenerateToken`, payload, {
      headers: {
        "Authorization": "Bearer " + accessToken
      }
    })
  }

  getReportFromPowerBI(accessToken: string, workSpaceId: string, reportIdWithoutFilter: string) {
    return this.http.get(`${config.apiUrl}v1.0/myorg/groups/${workSpaceId}/reports/${reportIdWithoutFilter}`, {
      headers: {
        "Authorization": "Bearer " + accessToken
      }
    })
  }
  getPowerBiToken(): string {
    return this.accessToken;
  }
  acknowledgeUserNotificationDelivary(deliver: any) {
    return this.http.post<any>(environment.apiUrl + 'Notifications/AcknowledgeUserNotification', deliver);
  }
  getLeadInfoByLeadId(leadId: any): Observable<any> {
    return this.http.get(`${environment.apiUrl}Notifications/GetLeadDetailsByLeadId/${leadId}`);
  }
  updateUserStatus(payload: any): Observable<any> {
    return this.http.put(`${environment.apiUrl}Notifications/UpdateUserStatusInNotification`, payload);
  }

  globalExport(payload: ExportOptions): Observable<any> {
    return this.http.post(`${environment.apiUrl}Contacts/ExportReport`, payload);
  }

  loadingShow() {

  }

  loadingHide() {

  }
  callStart(payload: any) {
    // disable feature for AINU
    return null;
    //return this.http.post<any>(environment.apiUrl + 'TataDialer/CallStart', payload);
  }
  
  callEnd(payload: any) {
    return this.http.post<any>(environment.apiUrl + 'TataDialer/CallEnd', payload);
  }
  
  SIPCall(payload: any) {
    return this.http.post<any>(environment.apiUrl + 'TataDialer/SIPCall', payload);
  }
  
  
updateApprovalStatus(payload:any)
  {
    return this.http.post<any>(environment.apiUrl + 'UserManagement/UpdateRoleApproval', payload);
  }
}
